import { login, logout as _logout, getInfo, getAbility as _getAbility, getCompanyInfo, getSellUsers as _getSellUsers, getMenus as _getMenus, getMyAvatar as _getMyAvatar, getServiceName as _getServiceName } from '@/api/user';
import { getCardChannelGroup, getOrganizeTree } from '@/api/order';
import { getToken, setToken, removeToken } from '@/utils/auth';
import { resetRouter } from '@/router';
import router from '@/router';
import { getOperateUserList as _getOperateUserList } from '@/api/giftPackApi';
import Cookies from 'js-cookie';
import { getInvoiceTips } from '@/api/dataCenter';
import store from "../../store";
var getDefaultState = function getDefaultState() {
  return {
    token: getToken(),
    name: '',
    avatar: '',
    role: '',
    roles: [],
    menus: [],
    // 菜单列表
    companyList: [],
    // 公司列表
    companyChannelList: [],
    // 渠道公司列表
    cardTypeChannelList: [],
    sellUsersList: [],
    // 销售人员列表
    sellChannelUsersList: [],
    // 渠道销售人员列表
    organizeList: [],
    // 组织列表
    organizeChannelList: [],
    // 组织列表
    operateUserList: [],
    // 运营人员
    userInfo: {},
    // 用户信息
    head: '',
    invoiceTips: '',
    // 开票信息
    serviceName: '',
    domainName: window.location.origin,
    monthList: [{
      id: '1',
      name: '1月'
    }, {
      id: '2',
      name: '2月'
    }, {
      id: '3',
      name: '3月'
    }, {
      id: '4',
      name: '4月'
    }, {
      id: '5',
      name: '5月'
    }, {
      id: '6',
      name: '6月'
    }, {
      id: '7',
      name: '7月'
    }, {
      id: '8',
      name: '8月'
    }, {
      id: '9',
      name: '9月'
    }, {
      id: '10',
      name: '10月'
    }, {
      id: '11',
      name: '11月'
    }, {
      id: '12',
      name: '12月'
    }]
  };
};
var state = getDefaultState();
var mutations = {
  RESET_STATE: function RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar;
  },
  SET_ROLE: function SET_ROLE(state, role) {
    state.role = role;
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  },
  // 获取公司列表
  companyList: function companyList(state, list) {
    state.companyList = list;
  },
  // 销售人员列表
  sellUsersList: function sellUsersList(state, list) {
    state.sellUsersList = list;
  },
  // 运营人员
  operateUserList: function operateUserList(state, list) {
    state.operateUserList = list;
  },
  // 获取卡类型渠道列表列表
  cardTypeChannelList: function cardTypeChannelList(state, list) {
    state.cardTypeChannelList = list;
  },
  SET_USER_INFO: function SET_USER_INFO(state, info) {
    state.userInfo = info;
  },
  SET_MENUS: function SET_MENUS(state, menus) {
    state.menus = menus;
  },
  SET_HEAD: function SET_HEAD(state, head) {
    state.head = head;
  },
  SET_SERVICENAME: function SET_SERVICENAME(state, serviceName) {
    state.serviceName = serviceName;
  },
  SET_DOMAIN_NAME: function SET_DOMAIN_NAME(state, domainName) {
    state.domainName = domainName;
  },
  SET_TIPS: function SET_TIPS(state, msg) {
    state.invoiceTips = msg;
  },
  organizeList: function organizeList(state, data) {
    state.organizeList = data;
  },
  companyChannelList: function companyChannelList(state, data) {
    state.companyChannelList = data;
  },
  sellChannelUsersList: function sellChannelUsersList(state, data) {
    state.sellChannelUsersList = data;
  },
  organizeChannelList: function organizeChannelList(state, data) {
    state.organizeChannelList = data;
  }
};
var actions = {
  // user login
  login: function login(_ref, authKey) {
    var commit = _ref.commit;
    // return new Promise((resolve, reject) => {
    console.log(authKey, 'authKey');
    // login({ authKey: authKey }).then(response => {
    // const { data } = response
    console.log(authKey);
    commit('SET_TOKEN', authKey);
    // commit('SET_role', data.role)
    setToken(authKey);
    resolve();
    // }).catch(error => {
    //   reject(error)
    // })
    // })
  },
  // 获取菜单权限
  getMenus: function getMenus(_ref2) {
    var commit = _ref2.commit,
      state = _ref2.state;
    return new Promise(function (resolve, reject) {
      _getMenus().then(function (response) {
        // response.data[15].children.push({
        // 	component: '@/views/cardSystem/saleToos/customerQuery',
        // 	children: [],
        // 	jump_path: 1,
        // 	title: '客户查询',
        // 	redirect: '/cardSystem/saleToos/customerQuery',
        // 	path: '/cardSystem/saleToos/customerQuery',
        // 	sideRoute: true
        // })
        // response.data.length = 3
        var menus = response.data;
        // if (!roles) {
        // 	reject('Verification failed, please Login again.')
        // }
        // roles must be a non-empty array
        // if (!roles || roles.length <= 0) {
        // 	reject('getInfo: roles must be a non-null array!')
        // }
        commit('SET_MENUS', menus);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 获取开票说明
  getTips: function getTips(_ref3, state) {
    var commit = _ref3.commit;
    return new Promise(function (resolve, reject) {
      getInvoiceTips({
        cat: state
      }).then(function (response) {
        commit('SET_TIPS', response.data.msg);
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 获取接口权限
  getInfo: function getInfo(_ref4) {
    var commit = _ref4.commit,
      state = _ref4.state;
    return new Promise(function (resolve, reject) {
      _getAbility().then(function (response) {
        var _ref5 = response.data || {},
          _ref5$user = _ref5.user,
          user = _ref5$user === void 0 ? {} : _ref5$user;
        var roles = response.data.ability;
        if (!roles) {
          reject('Verification failed, please Login again.');
        }
        // roles must be a non-empty array
        if (!roles || roles.length <= 0) {
          reject('getInfo: roles must be a non-null array!');
        }
        commit('SET_ROLES', roles);
        commit('SET_USER_INFO', user);
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // user logout
  logout: function logout(_ref6) {
    var commit = _ref6.commit,
      state = _ref6.state;
    return new Promise(function (resolve, reject) {
      _logout().then(function () {
        var frame = document.createElement('iframe');
        frame.src = "".concat(process.env.VUE_APP_BASE_API, "site/logout");
        frame.id = 'logoutFrame';
        frame.width = 0;
        frame.height = 0;
        frame.style.display = 'none';
        document.body.appendChild(frame);
        frame.onload = function () {
          document.getElementById('logoutFrame').remove();
        };
        removeToken(); // must remove  token  first
        resetRouter();
        commit('RESET_STATE');
        store.state.permission.routes = [];
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // remove token
  resetToken: function resetToken(_ref7) {
    var commit = _ref7.commit;
    return new Promise(function (resolve) {
      removeToken(); // must remove  token  first
      commit('RESET_STATE');
      resolve();
    });
  },
  getAbility: function getAbility(_ref8) {
    var commit = _ref8.commit;
    return new Promise(function (resolve, reject) {
      _getAbility().then(function (response) {
        commit('SET_ROLE', response.data.ability);
      }).catch();
    });
  },
  getMyAvatar: function getMyAvatar(_ref9) {
    var commit = _ref9.commit;
    return new Promise(function (resolve, reject) {
      _getMyAvatar().then(function (response) {
        // commit('SET_LINKITEM', data)
        commit('SET_HEAD', response.data);

        // if (response.data.avatar) {
        //   commit('SET_HEAD', response.data)
        // } else {
        //   commit('SET_HEAD', 'http://storage.youlianfuwu.com/timg.jpg')
        // }
        resolve();
      }).catch(function (error) {
        // commit('SET_HEAD', 'http://storage.youlianfuwu.com/timg.jpg')
        reject(error);
      });
    });
  },
  // 获取当班客服
  getServiceName: function getServiceName(_ref10) {
    var commit = _ref10.commit;
    return new Promise(function (resolve, reject) {
      _getServiceName().then(function (response) {
        if (response.data) {
          commit('SET_SERVICENAME', response.data);
        } else {
          commit('SET_SERVICENAME', '');
        }
        resolve();
      }).catch(function (error) {
        commit('SET_SERVICENAME', '');
        reject(error);
      });
    });
  },
  // 获取运营人员
  getOperateUserList: function getOperateUserList(_ref11) {
    var commit = _ref11.commit,
      state = _ref11.state;
    return new Promise(function (resolve, reject) {
      _getOperateUserList().then(function (response) {
        commit('operateUserList', response.data.list);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 获取公司列表信息
  getCardChannelType: function getCardChannelType(_ref12) {
    var commit = _ref12.commit;
    return new Promise(function (resolve, reject) {
      getCardChannelGroup().then(function (response) {
        commit('cardTypeChannelList', response.data);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 获取公司列表信息
  getCompanyList: function getCompanyList(_ref13) {
    var commit = _ref13.commit;
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$val = params.val,
      val = _params$val === void 0 ? '' : _params$val,
      is_delete = params.is_delete,
      _params$is_create = params.is_create,
      is_create = _params$is_create === void 0 ? '' : _params$is_create,
      _params$is_account = params.is_account,
      is_account = _params$is_account === void 0 ? '' : _params$is_account;
    is_delete = is_delete === undefined ? '0' : is_delete;
    is_account = is_account === undefined ? '0' : is_account;
    return new Promise(function (resolve, reject) {
      getCompanyInfo({
        company_name: val,
        page_size: 500,
        is_delete: is_delete,
        is_create: is_create,
        is_account: is_account
      }).then(function (response) {
        commit('companyList', response.data.list.slice(0, 500));
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 获取销售人员
  getSellUsers: function getSellUsers(_ref14) {
    var commit = _ref14.commit,
      state = _ref14.state;
    return new Promise(function (resolve, reject) {
      _getSellUsers().then(function (response) {
        commit('sellUsersList', response.data.list);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 获取组织
  getOrganizeList: function getOrganizeList(_ref15) {
    var commit = _ref15.commit;
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return new Promise(function (resolve, reject) {
      var data = params;
      getOrganizeTree(data).then(function (response) {
        commit('organizeList', response.data.list);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 获取渠道公司列表
  getChannelCompanyList: function getChannelCompanyList(_ref16) {
    var commit = _ref16.commit;
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$val2 = params.val,
      val = _params$val2 === void 0 ? '' : _params$val2,
      is_delete = params.is_delete,
      _params$c_unionid = params.c_unionid,
      c_unionid = _params$c_unionid === void 0 ? '' : _params$c_unionid;
    is_delete = is_delete === undefined ? '0' : is_delete;
    return new Promise(function (resolve, reject) {
      getCompanyInfo({
        company_name: val,
        page_size: 500,
        is_delete: is_delete,
        c_unionid: c_unionid
      }).then(function (response) {
        commit('companyChannelList', response.data.list.slice(0, 500));
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 获取渠道销售人员
  getChannelSellUsers: function getChannelSellUsers(_ref17) {
    var commit = _ref17.commit;
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return new Promise(function (resolve, reject) {
      var data = params;
      _getSellUsers(data).then(function (response) {
        commit('sellChannelUsersList', response.data.list);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 获取渠道组织
  getOrganizeChannelList: function getOrganizeChannelList(_ref18) {
    var commit = _ref18.commit;
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return new Promise(function (resolve, reject) {
      var data = params;
      getOrganizeTree(data).then(function (response) {
        commit('organizeChannelList', response.data.list);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};